import(/* webpackMode: "eager" */ "D:\\Klienti - D\\WHO bg\\www - AI\\src\\app\\general-terms\\page.tsx");
